/**
 * Returns a function that will execute after `wait` milliseconds. If the debounced function is called before the wait
 * time passes, the wait time is reset.
 */
export function debounce(fn, wait) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            fn(...args);
        }, wait);
    };
}
//# sourceMappingURL=debounce.js.map